import { Capacitor } from "@capacitor/core";
import React, { useContext, useEffect, useState } from "react";
import filesystem from "../../app/filesystem/filesystem";
import { getExistingAssetUrl } from "../../app/models/content";
import { ITenant } from "../../app/models/tenant";
import { RootStoreContext } from "../../app/stores/rootStore";

interface IParams {
  tenant: ITenant;
  className?: string;
  sidebarLogo?: boolean;
}

const TenantLogo: React.FC<IParams> = ({ tenant, className, sidebarLogo }) => {
  const rootStore = useContext(RootStoreContext);
  const { isNativeApp } = rootStore.commonStore;
  const [imgSrc, setImgSrc] = useState("");

  useEffect(() => {
    const ts = new Date().getMilliseconds();
    const logoFilename = sidebarLogo ? "logo_sidebar.png" : "logo.png";
    const defaultUri = `${getExistingAssetUrl("tenants", tenant.path, logoFilename)}?ts=${ts}`;
    if (isNativeApp) {
      filesystem.GetLocalUrl.tenantLogo(tenant, logoFilename)
        .then((url) => {
          if (url) setImgSrc(Capacitor.convertFileSrc(url));
          else setImgSrc(defaultUri);
        })
        .catch(() => setImgSrc(defaultUri));
    } else setImgSrc(defaultUri);
  }, [isNativeApp, tenant, sidebarLogo]);

  return <img alt={tenant.name} className={className} src={imgSrc} />;
};

export default TenantLogo;
